// components/PageTitleUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const routeTitleMap = {
  "/user/home": "Home",
  "/user/chat": "Chat",
  "/user/new": "Chat",
  "/user/imagetotext": "Image to Text",
  "/user/imagetovideo": "Image to Video",
  "/user/audiototext": "Audio to Text",
  "/user/audiotoaudio": "Audio to Audio",
  "/user/audiotochat": "Audio to Chat",
  "/user/pdftoall": "PDF Toolkit",
  "/user/activity-log": "Activity Log",
  "/user/dashboard": "Dashboard",
  "/user/dashboard/financial_advisory": "Financial Advisory",
  "/user/dashboard/prediction-page": "Prediction Use Case",
  "/user/dashboard/pothole_detection": "Pothole Detection",
  "/user/dashboard/accident_detection": "Accident Detection",
  "/user/dashboard/house_predict": "House Price Prediction",
  "/user/dashboard/rainfall_predict": "Rainfall Prediction",
  "/user/dashboard/weather_predict": "Weather Prediction",
  "/user/dashboard/fraud_detection": "Fraud Detection",
  "/user/dashboard/fraud_detection/specific_transaction": "Specific Transaction",
  "/user/dashboard/fraud_detection/multiple_transaction": "Multiple Transaction",
  "/user/dashboard/delivery-eta": "Delivery ETA",
  "/user/dashboard/churn_prediction": "Churn Prediction",

  "/superadmin/enterprise": "Enterprise",
  "/superadmin/activity-log": "Activity Log",
  "/superadmin/role-management": "Role Management",
  "/superadmin/module": "Module Management",
  "/superadmin/users": "User Management",

  "/admin/activity-log": "Activity Log",

  "/": "Login",
  "/forgot-password": "Forgot Password",
  "/verify-email": "Verify Email",
  "/reset-password": "Reset Password",
};

export default function PageTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Find the longest matching prefix in the map
    const matchedRoute = Object.keys(routeTitleMap)
      .filter((route) => path.startsWith(route))
      .sort((a, b) => b.length - a.length)[0];

    const title = routeTitleMap[matchedRoute] || "ThinkStore App";
    document.title = `ThinkStore | ${title}`;
  }, [location.pathname]);

  return null;
}
